import React from 'react';

import cn from 'classnames';

import { LightboxHeader } from '@features/ReceiptImage/ui/LightboxHeader';
import { Flex, Icon, Lightbox, UiButton, useLightBoxControl } from '@shared/ui';

import cls from './ReceiptImage.module.css';

interface ReceiptImageProps {
    classes?: string;
    attachmentUrl?: string;
    attachmentId?: number;
}

export const ReceiptImage = ({ classes, attachmentUrl, attachmentId }: ReceiptImageProps) => {
    const { files, currentFileId, onShowLightBox, onCloseLightBox } = useLightBoxControl();

    const onOpen = () => {
        if (!attachmentUrl || !attachmentId) return;
        onShowLightBox({
            id: attachmentId,
            newFiles: [{ id: attachmentId, fileSrc: attachmentUrl, mimeType: 'image' }],
        });
    };

    return (
        <>
            <Flex align="center" justify="center" className={cn(cls.ReceiptImage, [classes])}>
                <UiButton
                    className={cls.ReceiptImageButton}
                    variant="icon"
                    startIcon={<Icon iconName="receiptImg" />}
                    onClick={onOpen}
                />
            </Flex>
            {!!attachmentId && currentFileId === attachmentId && (
                <Lightbox
                    headerSlot={<LightboxHeader onClose={onCloseLightBox} />}
                    files={files}
                    currentFileId={currentFileId as number}
                    onClose={onCloseLightBox}
                />
            )}
        </>
    );
};
